import { experienceQueryKeys as e } from "./useExperienceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { experiencesApi as r } from "@maat/api-main";
//#region src/experiences/useCreateExperienceMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.createExperience(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useCreateExperienceMutation };
